import { render } from "./AgrotourismDataForm.vue?vue&type=template&id=65471bc4&scoped=true&ts=true"
import script from "./AgrotourismDataForm.vue?vue&type=script&lang=ts"
export * from "./AgrotourismDataForm.vue?vue&type=script&lang=ts"

import "./AgrotourismDataForm.vue?vue&type=style&index=0&id=65471bc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65471bc4"]])

export default __exports__